import L from "leaflet";

export const _log = (label, data) => {
    if (process.env.REACT_APP_DEVELOPMENT_ENV === "dev") {
        console.log(`[DEBUG] ${label}:`, data ?? "");
    }
};

export const mergeLogs = (existing = [], incoming = [], age) => {
    const fresh = incoming.map(l => ({ ...l, age }));
    const merged = [...existing.filter(e => !fresh.some(f => f.id === e.id) && (age === undefined || e.age !== age)), ...fresh];
    return merged.sort((a, b) => new Date(a.logDate) - new Date(b.logDate));
};

export const initialBounds = L.latLngBounds([
    [8.9, 38.7],
    [9.1, 38.9],
]);
export const POLYLINE_COLORS = { TODAY: "#FFC107", YESTERDAY: "#FF5733", OLD: "#f5f5f5" }; //808080

export const getCoordinates = coordinates => {
    if (!coordinates || !coordinates.includes(",")) return [8.98, 38.75];
    const [lat, lng] = coordinates.split(",");
    return [parseFloat(lat) || 0, parseFloat(lng) || 0];
};

export const getLatLon = coordinates => {
    if (!coordinates || !coordinates.includes(",")) return { lat: null, lon: null };
    const [lat, lng] = coordinates.split(",");
    return { lat: parseFloat(lat), lon: parseFloat(lng) };
};

export const calculateDistance = (loc1, loc2) => {
    if (!loc1?.lat || !loc2?.lat) return null;
    const R = 6371;
    const dLat = (loc2.lat - loc1.lat) * (Math.PI / 180);
    const dLon = (loc2.lon - loc1.lon) * (Math.PI / 180);
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(loc1.lat * (Math.PI / 180)) * Math.cos(loc2.lat * (Math.PI / 180)) * Math.sin(dLon / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

export const getLatestCoordinate = (vehicle, detailedLogs) => {
    if (!detailedLogs || detailedLogs.length === 0) return vehicle.lastLocation;
    const lastLogEntry = detailedLogs[detailedLogs.length - 1];
    return new Date(lastLogEntry.logDate).getTime() > new Date(vehicle.lastLog).getTime() ? lastLogEntry.coordinate : vehicle.lastLocation;
};

export const easeInOutCubic = t => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
